import * as s from "react";
import w from "react";
import * as C from "react-dom";
var v = { exports: {} }, m = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _;
function P() {
  if (_) return m;
  _ = 1;
  var e = w, r = 60103;
  if (m.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var o = Symbol.for;
    r = o("react.element"), m.Fragment = o("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, a, f) {
    var c, p = {}, y = null, R = null;
    f !== void 0 && (y = "" + f), a.key !== void 0 && (y = "" + a.key), a.ref !== void 0 && (R = a.ref);
    for (c in a) t.call(a, c) && !i.hasOwnProperty(c) && (p[c] = a[c]);
    if (l && l.defaultProps) for (c in a = l.defaultProps, a) p[c] === void 0 && (p[c] = a[c]);
    return { $$typeof: r, type: l, key: y, ref: R, props: p, _owner: n.current };
  }
  return m.jsx = u, m.jsxs = u, m;
}
var S;
function j() {
  return S || (S = 1, v.exports = P()), v.exports;
}
var d = j();
function E(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function x(...e) {
  return (r) => {
    let o = !1;
    const n = e.map((t) => {
      const i = E(t, r);
      return !o && typeof i == "function" && (o = !0), i;
    });
    if (o)
      return () => {
        for (let t = 0; t < n.length; t++) {
          const i = n[t];
          typeof i == "function" ? i() : E(e[t], null);
        }
      };
  };
}
function k(...e) {
  return s.useCallback(x(...e), e);
}
// @__NO_SIDE_EFFECTS__
function O(e) {
  const r = /* @__PURE__ */ I(e), o = s.forwardRef((n, t) => {
    const { children: i, ...u } = n, l = s.Children.toArray(i), a = l.find(T);
    if (a) {
      const f = a.props.children, c = l.map((p) => p === a ? s.Children.count(f) > 1 ? s.Children.only(null) : s.isValidElement(f) ? f.props.children : null : p);
      return /* @__PURE__ */ d.jsx(r, { ...u, ref: t, children: s.isValidElement(f) ? s.cloneElement(f, void 0, c) : null });
    }
    return /* @__PURE__ */ d.jsx(r, { ...u, ref: t, children: i });
  });
  return o.displayName = `${e}.Slot`, o;
}
var U = /* @__PURE__ */ O("Slot");
// @__NO_SIDE_EFFECTS__
function I(e) {
  const r = s.forwardRef((o, n) => {
    const { children: t, ...i } = o;
    if (s.isValidElement(t)) {
      const u = D(t), l = A(i, t.props);
      return t.type !== s.Fragment && (l.ref = n ? x(n, u) : u), s.cloneElement(t, l);
    }
    return s.Children.count(t) > 1 ? s.Children.only(null) : null;
  });
  return r.displayName = `${e}.SlotClone`, r;
}
var b = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function z(e) {
  const r = ({ children: o }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: o });
  return r.displayName = `${e}.Slottable`, r.__radixId = b, r;
}
function T(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === b;
}
function A(e, r) {
  const o = { ...r };
  for (const n in r) {
    const t = e[n], i = r[n];
    /^on[A-Z]/.test(n) ? t && i ? o[n] = (...l) => {
      const a = i(...l);
      return t(...l), a;
    } : t && (o[n] = t) : n === "style" ? o[n] = { ...t, ...i } : n === "className" && (o[n] = [t, i].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function D(e) {
  var n, t;
  let r = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, o = r && "isReactWarning" in r && r.isReactWarning;
  return o ? e.ref : (r = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, o = r && "isReactWarning" in r && r.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var V = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], g = V.reduce((e, r) => {
  const o = /* @__PURE__ */ O(`Primitive.${r}`), n = s.forwardRef((t, i) => {
    const { asChild: u, ...l } = t, a = u ? o : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d.jsx(a, { ...l, ref: i });
  });
  return n.displayName = `Primitive.${r}`, { ...e, [r]: n };
}, {});
function B(e, r) {
  e && C.flushSync(() => e.dispatchEvent(r));
}
var L = "Separator", h = "horizontal", $ = ["horizontal", "vertical"], F = s.forwardRef((e, r) => {
  const { decorative: o, orientation: n = h, ...t } = e, i = W(n) ? n : h, l = o ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ d.jsx(
    g.div,
    {
      "data-orientation": i,
      ...l,
      ...t,
      ref: r
    }
  );
});
F.displayName = L;
function W(e) {
  return $.includes(e);
}
var q = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), H = "VisuallyHidden", N = s.forwardRef(
  (e, r) => /* @__PURE__ */ d.jsx(
    g.span,
    {
      ...e,
      ref: r,
      style: { ...q, ...e.style }
    }
  )
);
N.displayName = H;
var M = N;
export {
  g as P,
  M as R,
  U as S,
  N as V,
  z as a,
  F as b,
  O as c,
  B as d,
  d as j,
  k as u
};
//# sourceMappingURL=radix-common-Dx8bZddK.js.map
